<template>
    <form v-loading="isLoading" @submit.prevent="send">
        <div class="form-row">
            <div class="form-group col-12">
                <label class="mb-0" :for="'platform_id' + _uid">Площадка</label>
                <Select2 :disabled="mode !== 'create'" v-model="platform_id" :options="platform_select" :id="'platform_id' + _uid" :settings="{width: '100%'}"/>
                <has-error :form="form" field="platform_id" class="d-block"/>
            </div>
            <div class="form-group col-12">
                <label class="mb-0" :for="'name' + _uid">Название продукта</label>
                <div class="custom-control custom-switch ml-3 d-inline">
                    <input type="checkbox" class="custom-control-input" :id="'status' + _uid" v-model="status">
                    <label class="custom-control-label" :for="'status' + _uid">Статус</label>
                </div>
                <input type="text" class="form-control" :id="'name' + _uid" v-model="name" required>
                <has-error :form="form" field="name" class="d-block"/>
            </div>
            <div class="form-group col-12">
                <label class="mb-0" :for="'category_name' + _uid">Категория</label>
                <el-select class="d-block" :id="'category_name' + _uid" v-model="category_name" size="mini" filterable allow-create no-data-text="Нет категорий! Добавьте новую!" >
                    <el-option v-for="c in categories" :key="c" :label="c" :value="c"></el-option>
                </el-select>
                <has-error :form="form" field="category_name" class="d-block"/>
            </div>
            <div class="form-group col-12">
                <label class="mb-0" :for="'company' + _uid">Юр лицо</label>
                <CounteragentSelect v-model="company_id" :filter_type="'company'" :filter_platforms="[0]" :filter_category="'other'" class="multiselect-bootstrap" :id="'company' + _uid"/>
                <has-error :form="form" field="company_id" class="d-block"/>
            </div>
            <div class="form-group col-6">
                <label class="mb-0" :for="'sale_amount' + _uid">Сумма продажи</label>
                <input type="text" class="form-control" :id="'sale_amount' + _uid" v-model="sale_amount" required>
                <has-error :form="form" field="sale_amount" class="d-block"/>
            </div>
            <div class="form-group col-6">
                <label class="mb-0" :for="'fee_percent' + _uid">% КВ</label>
                <input type="text" class="form-control" :id="'fee_percent' + _uid" v-model="fee_percent" required v-float>
                <has-error :form="form" field="fee_percent" class="d-block"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12">
                <button type="submit" v-if="mode === 'create' && $hasPermission('affiliate_programs.create')" class="btn btn-primary">Создать</button>
                <button type="submit" v-if="mode === 'edit' && $hasPermission('affiliate_programs.update')" class="btn btn-primary">Сохранить</button>
            </div>
        </div>
    </form>
</template>

<script>
import Form from "vform";
import CounteragentSelect from "../counteragents/CounteragentSelect";
import {mapGetters} from "vuex";

export default {
    name: "AffiliateProgramForm",
    components: {CounteragentSelect},
    props: {
        program: {
            type: Object,
            required: false,
        },
        mode: {
            type: String,
            required: true,
            validator: function (value) {
                return ['create', 'edit'].indexOf(value) !== -1
            }
        },
    },
    data: () => ({
        form: new Form({}),
        isLoading: false,

        id: null,
        platform_id: null,
        status: false,
        name: null,
        category_name: null,
        company_id: null,
        sale_amount: 0,
        fee_percent: 0,
    }),
    mounted() {
        if (this.program) {
            if (this.program.platform_id !== undefined) this.platform_id = this.program.platform_id;
            if (this.program.id !== undefined) this.id = this.program.id;
            if (this.program.name !== undefined) this.name = this.program.name;
            if (this.program.status !== undefined) this.status = !!this.program.status;
            if (this.program.category_name !== undefined) this.category_name = this.program.category_name;
            if (this.program.company_id !== undefined) this.company_id = this.program.company_id;
            if (this.program.sale_amount !== undefined) this.sale_amount = this.program.sale_amount / 100;
            if (this.program.fee_percent !== undefined) this.fee_percent = this.program.fee_percent;
        }
    },
    computed: {
        platform_select () {
            let select = [];
            this.$store.getters['auth/user'].allowed_platforms.forEach(function (item) {select.push({id: item.id, text: item.name,})});
            select = _.sortBy(select, ['text']);
            return select;
        },
        ...mapGetters({
            categories: "affiliate_program_categories/all",
        })
    },
    methods: {
        makeForm() {
            this.form = new Form({
                id: this.id,
                platform_id: this.platform_id,
                name: this.name,
                status: this.status,
                category_name: this.category_name,
                company_id: this.company_id,
                sale_amount: this.sale_amount,
                fee_percent: this.fee_percent,
            });
        },
        send() {
            if (this.program && this.program.id) {
                this.edit();
            } else {
                this.create();
            }
        },
        create(){
            let self = this;
            this.makeForm();
            this.isLoading = true;
            this.form.post('/api/affiliate_programs')
                .then(response => {
                    self.$emit('created', response.data);
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Создано',
                        duration: 2000,
                    });
                    self.$emit('saved');
                })
                .catch(() => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка при создании, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
        edit(){
            let self = this;
            this.makeForm();
            this.isLoading = true;
            this.form.put('/api/affiliate_programs/' + this.program.id)
                .then(response => {
                    self.$emit('updated', response.data);
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Сохранено',
                        duration: 2000,
                    });
                    self.$emit('saved');
                })
                .catch(() => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
    }
}
</script>

<style scoped>

</style>
